import $ from 'jquery';
import Util from './utility';

const scrollOptions = {
  duration: 1000
};


const scroll_to_anchor = (href, animate=true) => {
  if ('string' !== typeof href || href.length <= 1) {
    return false;
  }

  const hashPos = href.indexOf("#");

  if (-1 == hashPos) {
    return false;
  }

  // let offset = $('.site-header__inner').height() - 1;
  let offset = 82;

  const $target = $(href.substr(hashPos));
  const options = $.extend({}, scrollOptions, {
    duration: animate ? scrollOptions.duration : 0,
    offset: offset
  });

  if (!$target.length) {
    return false;
  }

  setTimeout(() => Util.scrollTo($target, options), 0);

  return $target;
};    

$(() => {
  // Scroll to anchor on page load without animation
  scroll_to_anchor(window.location.hash, false);

  // Intercept anchor clicks and scroll to them with animation
  $(document).on("click", "a", function (e) {
    if (scroll_to_anchor($(this).attr('href'))) {
      e.preventDefault();
    }
  });
});
